/**
 * @file footer-items.js
 * @description Itens do footer da sidebar (CRA)
 */

import { AccountBoxOutlined } from "@mui/icons-material"
import { Laptop, LogOut, Settings, User } from "lucide-react"

/**
 * Itens do footer da sidebar
 */
export const FOOTER_ITEMS = [
  {
    icon: User,
    label: "Usuários",
    id: "usuarios",
    href: "/user",
    description: "Gerenciar usuários",
    permission: "Usuario",
    action: "islist",
  },
  {
    icon: Laptop,
    label: "Suporte",
    id: "suporte",
    href: "https://trendsuport3.glide.page",
    description: "Acessar suporte",
    permission: "Suporte",
    action: "isinsert",
  },
  {
    icon: Settings,
    label: "Configurações",
    id: "configuracao",
    href: "/listConfiguration",
    description: "Gerenciar configurações",
    permission: "Configuração",
    action: "islist",
  },
]
